module.exports = __webpack_public_path__ + "img/112017.ed67e285.png";